<template>
  <i18n-t
    v-if="mention.original_language"
    class="q-pt-md"
    keypath="mention_translation_language.translated_from"
    scope="global"
    tag="div"
  >
    <template #translated>
      <span class="text-weight-bold">
        <img
          alt=""
          class="q-icon notranslate"
          src="https://assets.streem.com.au/icons/translated-content.png"
        />
        {{ $t("mention_translation_language.translated") }}
      </span>
    </template>
    <template #originalLanguage>
      {{ mention.original_language }}
    </template>
  </i18n-t>
</template>

<script>
export default {
  name: "MentionTranslationLanguage",
  props: {
    mention: {
      type: Object,
      required: true,
    },
  },
};
</script>
